export default "__VITE_ASSET__CmptxywE__"